import React, { useEffect, useState } from "react";
import { get } from "util/requests";
import styles from "../../dashboard.module.css";
import LineChart from "../../components/line_chart";
import SiteList from "../../components/site_list";
import Filters from "../../components/filters";
import KPI from "../../components/kpi";

export default function EnrollmentDashboard(props) {
  const { params } = props;
  const [data, setData] = useState(null);

  useEffect(() => {
    get("/enrollment_kpis", { params: { ...params, study_id: 1 } }).then(({ data }) => {
      setData(data);
    });
  }, [params.filter, params.site, params.region]);
  return (
    <React.Fragment>
      <Filters {...props} params={params} />
      <div className={styles.row}>
        <div className={styles.split_70}>
          <div className={styles.kpi_row}>
            <KPI title={"Total Enrolled"} value={data?.total} />
            <KPI title={"ACT42 Enrolled"} value={data?.act42} />
            <KPI title={"BP Enrolled"} value={data?.bp} />
          </div>
          <div className={styles.kpi_row}>
            <KPI title={"ACTWHEN Enrolled"} value={data?.actwhen} />
            <KPI title={"ACTWHEN EVT+"} value={data?.actwhen_evt} />
            <KPI title={"ACTWHEN DOAC+"} value={data?.actwhen_doac} />
          </div>
        </div>{" "}
        <div className={styles.split_30}>
          <SiteList sites_no_enrollment={data?.sites_no_enrollment} />
        </div>
      </div>
      <div>
        <div className={styles.kpi_row}>
          <LineChart {...props} params={params} />
        </div>
        <div className={styles.utc_note}>Note: All dates in UTC</div>
      </div>
    </React.Fragment>
  );
}
